import { render, staticRenderFns } from "./ControllerCard.vue?vue&type=template&id=0526c7f7&scoped=true&"
import script from "./ControllerCard.vue?vue&type=script&lang=js&"
export * from "./ControllerCard.vue?vue&type=script&lang=js&"
import style0 from "./ControllerCard.vue?vue&type=style&index=0&id=0526c7f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526c7f7",
  null
  
)

export default component.exports